import { sendImpressions, sendClick, sendEvent } from 'reaxl-analytics';

const createCustomEvent = () => {
    const event = document.createEvent('Event');
    event.initEvent('click', true, true);
    return event;
};

const callToActionAnalytics = {
    fireSearchSubmit(data) {
        // have to create custom event because one is not supplied
        const event = createCustomEvent();

        const {
            make = {},
            model = {},
            zip,
            listingTypes = '',
            ctaText,
        } = data;

        sendClick('searchSubmitClick', event, {
            // This birf object should all be handled in reaxl-analytics
            make: make.value || 'any',
            model: model.value || 'any',
            zip: zip || '',
            listingTypes: listingTypes || 'nl',
            co_txt_url: 'Search',
            ctaText,
        });
    },
    fireAdvancedSearchLink(event, data) {
        sendClick('advancedSearchClick', event, {
            ...data,
        });
    },
    fireBrowseByStyle(event, data) {
        sendClick('browsByStyleClick', event, {
            firePixall: true,
            isHP: true,
            co_txt_url: 'Browse By Style',
            ...data,
        });
    },
    fireBrowsByMakeClick(event, data) {
        sendClick('browsByMakeClick', event, {
            co_txt_url: 'Browse By Make',
            ...data,
        });
    },
    fireBrowsByBudgetClick(event, data) {
        sendClick('browsByBudgetClick', event, {
            co_txt_url: 'Search by Budget',
            ...data,
        });
    },
    fireMakeOnChangeClick(event, data) {
        sendClick('makeDropDownClick', event, {
            ...data,
            make: data.make || 'any',
        });
    },
    fireModelOnChangeClick(event, data) {
        sendClick('modelDropDownClick', event, {
            ...data,
            model: data.model || 'any',
        });
    },
    fireZipOnChangeEvent(event, data) {
        sendEvent({
            name: 'zipOnChange',
            event,
            data,
        });
    },
    fireReaxlSearchBtnClick(event, data) {
        sendClick('searchNearYouClick', event, {
            ...data,
        });
    },
    fireSearchByMakeClick(event, data) {
        sendClick('searchByMakeClick', event, {
            ...data,
        });
    },
    fireMostSearchClick(event, data) {
        sendClick('mostSearchClick', event, {
            ...data,
        });
    },
    fireCpoSearchClick(event, data) {
        sendClick('cpoSearchClick', event, {
            ...data,
        });
    },
    fireCpoLearnMoreClick(event, data) {
        sendClick('cpoLearnMoreClick', event, {
            ...data,
        });
    },
    fireFindModelsByMakeClick(event, data) {
        sendClick('findModelsByMakeClick', event, {
            ...data,
        });
    },
    fireContinueYourSearchClick(event, recentSearches, index) {
        const listing = recentSearches[index];
        const params = listing.query;
        const label = listing.fullHeading;
        sendClick('recentSearchClick', event, {
            // This birf object should all be handled in reaxl-analytics
            ct: params.listingTypes,
            make: params.makeCodeList,
            model: params.modelCodeList,
            yearf: params.startYear,
            yeart: params.endYear,
            label,
        });
    },

    fireContinueYourSearchImpression() {
        sendImpressions({
            name: 'recentSearchImpression',
        });
    },

    fireCapitalOneImpression(data) {
        sendImpressions({
            name: 'featuredPartnerImpression',
            data,
        });
    },

    fireCapitalOneClick(event, data) {
        // added new handler for GA Tags
        sendClick('featuredPartnerClick', event, {
            ...data,
        });
    },

    fireKbbLogoClick(event, data) {
        // added new handler for GA Tags
        sendClick('kbbLogoClick', event, {
            ...data,
        });
    },

    fireMyWalletGetStartedClick(event, data = {}) {
        sendClick('myWalletGetStartedClick', event, {});
    },

    fireSellingYourCarCTAClick(event, data = {}) {
        sendClick('sellingYourCarCTAClick', event, {
            ...data,
        });
    },

    fireBrowseByBudgetWalletContinue(event, data) {
        const { coTxtUrl = '', withPixallData } = data;
        sendClick('browseByBudgetWalletContinueClick', event, {
            co_txt_url: coTxtUrl,
            withPixallData,
        });
    },
    fireSetBudgetSearchFilter(event, data) {
        sendClick('setBudgetSearchFilter', event, { ...data });
    },
    fireMakeExampleLinkClick(event, data) {
        sendClick('makeExampleLinkClick', event, {
            ...data,
        });
    },
    fireModelExampleLinkClick(event, data) {
        sendClick('modelExampleLinkClick', event, {
            ...data,
        });
    },
    fireGoogleAssistantClick(event, data) {
        sendClick('googleAssistantClick', event, data);
    },

    fireAmazonAlexaClick(event, data) {
        sendClick('amazonAlexaClick', event, {
            ...data,
        });
    },
    fireCpoOffsiteClick(event, data) {
        const { makeLabel = '', ...rest } = data;
        sendClick('cpoOffsiteClick', event, {
            ...rest,
            pixallData: {
                make: makeLabel,
            },
        });
    },

    fireMarketValueLINKClick(event, data) {
        sendClick('marketValueLINKClick', event, {
            co_txt_url: 'Search available vehicles',
            ...data,
        });
    },

    fireMarketValueCTAClick(event, data) {
        sendClick('marketValueCTAClick', event, {
            ...data,
        });
    },

    fireAdditionalServicesLinkClick(event, data) {
        const { cmp = '', coTxtUrl = '', ...rest } = data;
        sendClick('deepLinkClick', event, {
            cmp,
            co_txt_url: coTxtUrl,
            ...rest,
        });
    },

    fireHeroAdCTAClick(event, data) {
        const {
            label = '',
            type = '',
            cmp = '',
            catalog = 'atc',
            makeId = '',
            makeName = '',
            modelId = '',
            modelName = '',
            year = '',
            es = '',
        } = data;

        sendEvent({
            name: 'heroAdCTAClick',
            event,
            data: {
                co_txt_url: label,
                text: label,
                type,
                cmp,
                catalog,
                makeId,
                makeName,
                modelId,
                modelName,
                year,
                es,
            },
        });
    },

    fireHomeServicesCTAClick(event, data) {
        sendClick('homeServicesCTAClick', event, {
            ...data,
        });
    },

    fireSetMyBudgetClick(event, data) {
        sendClick('setMyBudgetClick', event, {
            ...data,
            withPixallData: true,
        });
    },
    fireEditBudgetSideModule(event, data) {
        sendClick('editBudgetSideModule', event, {
            ...data,
        });
    },
    fireShopWithBudgetSideModule(event, data) {
        sendClick('shopWithBudgetSideModule', event, {
            ...data,
        });
    },
    fireMobileSmartBannerCTAClick(event, data) {
        sendClick('mobileSmartBannerCTAClick', event, {
            ...data,
        });
    },

    fireMobileSmartBannerImpression(data) {
        sendImpressions({
            name: 'mobileSmartBannerImpression',
            data,
        });
    },

    fireVideoMediaEvent(event, data) {
        sendClick('videoMediaEvent', event, {
            ...data,
        });
    },

    fireFindThatCarCTAClick(event, data) {
        sendClick('findThatCarCtaClick', event, {
            ...data,
        });
    },

    fireCarBravoCTAClick(event, data) {
        sendClick('carBravoCTAClick', event, {
            ...data,
        });
    },
};

export default callToActionAnalytics;
